const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;
  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);
    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;
        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) return 0;
  if (elementPositionY + elementHeight < scrollY) return 100;

  const distance = scrollY + viewportHeight - elementPositionY;
  const percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

function removeHydroviaFlashSale(rootEl = document) {
  if (!rootEl || !rootEl.querySelector) return;
  const flashSale = rootEl.querySelector('#hv-flash-sale');
  if (flashSale) flashSale.remove();
  try {
    localStorage.removeItem('hv_flash_deadline');
  } catch (error) {}
}

function hvSetText(root, selector, value) {
  root.querySelectorAll(selector).forEach((element) => {
    if (element.textContent.trim() !== value) element.textContent = value;
  });
}

function updateHydroviaNativeColorVisibility() {
  const card2 = document.getElementById('hv-card-2');
  const isBundle = Boolean(card2 && card2.classList.contains('hv-selected'));

  document.querySelectorAll('.product-form__input--pill.hv-native-color-upgraded').forEach((picker) => {
    picker.style.display = isBundle ? 'none' : 'block';
    picker.setAttribute('aria-hidden', isBundle ? 'true' : 'false');
  });
}

function updateHydroviaPricing(rootEl = document) {
  const root = rootEl && rootEl.querySelectorAll ? rootEl : document;

  root.querySelectorAll('.hv-promo-badge').forEach((element) => {
    const next = element.textContent.replace('$79', '$89');
    if (element.textContent !== next) element.textContent = next;
  });
  root.querySelectorAll('.hv-product-card .hv-price-new').forEach((element) => {
    if (element.textContent.trim() === '$79') element.textContent = '$89';
  });

  hvSetText(root, '#hv-card-1 .hv-old-price', '$139');
  hvSetText(root, '#hv-card-1 .hv-new-price', '$89');
  hvSetText(root, '#hv-card-1 .hv-sub', 'Regular price');
  hvSetText(root, '#hv-card-2 .hv-old-price', '$178');
  hvSetText(root, '#hv-card-2 .hv-new-price', '$158');
  hvSetText(root, '#hv-card-2 .hv-sub', '$79 each');
  hvSetText(root, '#hv-card-2 .hv-save-tag', 'SAVE $20');

  const card2 = document.getElementById('hv-card-2');
  const isBundle = card2 && card2.classList.contains('hv-selected');
  hvSetText(root, '#hv-btn-old', isBundle ? '$178' : '$139');
  hvSetText(root, '#hv-btn-new', isBundle ? '$158' : '$89');

  const banner = document.getElementById('hv-offer-banner');
  if (banner) {
    const html = isBundle
      ? '✦ <strong>Bundle price applied automatically</strong> — $158 total for 2 bottles'
      : '✦ <strong>Free shipping</strong> included on all orders';
    if (banner.innerHTML !== html) banner.innerHTML = html;
  }

  const installments = document.getElementById('hv-installments-text');
  if (installments) {
    const amount = isBundle ? '$39.50' : '$22.25';
    const html = 'Or <strong>4 interest-free payments</strong> of ' + amount;
    if (installments.innerHTML !== html) installments.innerHTML = html;
  }

  updateHydroviaNativeColorVisibility();
}

function wrapHydroviaBundleSelector() {
  if (window.hvSelect && !window.hvSelect.__hydroviaPriceWrapped) {
    const originalSelect = window.hvSelect;
    const wrappedSelect = function(qty) {
      originalSelect(qty);
      requestAnimationFrame(() => updateHydroviaPricing(document));
      setTimeout(() => updateHydroviaPricing(document), 120);
      setTimeout(() => updateHydroviaPricing(document), 350);
    };
    wrappedSelect.__hydroviaPriceWrapped = true;
    window.hvSelect = wrappedSelect;
  }
}

function installHydroviaPopup() {
  if (document.getElementById('hv-welcome-popup')) return;

  const style = document.createElement('style');
  style.id = 'hv-welcome-popup-style';
  style.textContent = `
    #hv-welcome-popup{position:fixed;inset:0;z-index:999999;display:none;align-items:center;justify-content:center;padding:18px;background:rgba(2,8,23,.68);backdrop-filter:blur(5px);font-family:Poppins,-apple-system,BlinkMacSystemFont,system-ui,sans-serif}
    #hv-welcome-popup.hv-open{display:flex}
    .hv-popup-card{position:relative;width:min(100%,460px);overflow:hidden;border-radius:26px;background:radial-gradient(circle at top right,rgba(56,189,248,.24),transparent 42%),linear-gradient(145deg,#06152f,#020817);border:1px solid rgba(125,211,252,.24);box-shadow:0 28px 80px rgba(2,8,23,.55);padding:38px 30px 30px;text-align:center;color:#fff}
    .hv-popup-close{position:absolute;top:14px;right:14px;width:34px;height:34px;border:1px solid rgba(255,255,255,.16);border-radius:50%;background:rgba(255,255,255,.08);color:#fff;font-size:22px;line-height:1;cursor:pointer}
    .hv-popup-eyebrow{font-size:10px;font-weight:800;letter-spacing:2.5px;text-transform:uppercase;color:#7dd3fc;margin-bottom:12px}
    .hv-popup-title{margin:0;color:#fff;font-size:34px;line-height:1.08;font-weight:800;letter-spacing:-1px}
    .hv-popup-copy{margin:14px auto 22px;max-width:350px;color:rgba(255,255,255,.72);font-size:14px;line-height:1.6}
    .hv-popup-code{display:flex;align-items:center;justify-content:space-between;gap:12px;background:rgba(255,255,255,.08);border:1px dashed rgba(125,211,252,.48);border-radius:14px;padding:11px 12px 11px 17px;margin-bottom:15px}
    .hv-popup-code strong{font-size:19px;letter-spacing:2px;color:#fff}
    .hv-popup-copy-btn{border:0;border-radius:10px;background:#fff;color:#06152f;padding:10px 14px;font-size:12px;font-weight:800;cursor:pointer}
    .hv-popup-shop{display:flex;align-items:center;justify-content:center;width:100%;min-height:50px;border-radius:13px;background:linear-gradient(180deg,#2bb7f3,#1488c4);color:#fff!important;text-decoration:none;font-size:14px;font-weight:800;box-shadow:0 14px 30px rgba(20,136,196,.34)}
    .hv-popup-note{margin-top:12px;color:rgba(255,255,255,.45);font-size:10px}
    @media(max-width:520px){.hv-popup-card{padding:34px 20px 24px;border-radius:22px}.hv-popup-title{font-size:29px}}
  `;
  document.head.appendChild(style);

  const popup = document.createElement('div');
  popup.id = 'hv-welcome-popup';
  popup.setAttribute('role', 'dialog');
  popup.setAttribute('aria-modal', 'true');
  popup.setAttribute('aria-label', 'Hydrovia welcome offer');
  popup.innerHTML = `
    <div class="hv-popup-card">
      <button type="button" class="hv-popup-close" aria-label="Close">×</button>
      <div class="hv-popup-eyebrow">Welcome to Hydrovia</div>
      <h2 class="hv-popup-title">Get 10% off<br>your first order</h2>
      <p class="hv-popup-copy">Upgrade your daily hydration and save 10% with your welcome code.</p>
      <div class="hv-popup-code"><strong>HYDRO10</strong><button type="button" class="hv-popup-copy-btn">Copy code</button></div>
      <a class="hv-popup-shop" href="/discount/HYDRO10?redirect=/products/hydrovi-hydrogen-water-bottle">Shop Hydrovia</a>
      <div class="hv-popup-note">One use per customer. Cannot be combined with other offers.</div>
    </div>`;
  document.body.appendChild(popup);

  const close = () => {
    popup.classList.remove('hv-open');
    try { sessionStorage.setItem('hv_popup_seen', '1'); } catch (error) {}
  };
  popup.querySelector('.hv-popup-close').addEventListener('click', close);
  popup.addEventListener('click', (event) => { if (event.target === popup) close(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
  popup.querySelector('.hv-popup-copy-btn').addEventListener('click', async function() {
    try {
      await navigator.clipboard.writeText('HYDRO10');
      this.textContent = 'Copied!';
    } catch (error) {
      this.textContent = 'HYDRO10';
    }
  });

  let alreadySeen = false;
  try { alreadySeen = sessionStorage.getItem('hv_popup_seen') === '1'; } catch (error) {}
  const designMode = Boolean(window.Shopify && Shopify.designMode);
  if (!alreadySeen || designMode) {
    setTimeout(() => popup.classList.add('hv-open'), designMode ? 1000 : 7000);
  }
}

function hydroviaColorClass(color) {
  return 'hv-color-' + String(color || '').toLowerCase().replace(/[^a-z0-9]+/g, '-');
}

function updateHydroviaColorControl(control, color) {
  if (!control) return;
  const dot = control.querySelector('.hv-premium-color-dot');
  if (!dot) return;
  dot.className = 'hv-premium-color-dot ' + hydroviaColorClass(color);
}

function installHydroviaColorSelectors(rootEl = document) {
  const root = rootEl && rootEl.querySelectorAll ? rootEl : document;

  if (!document.getElementById('hv-premium-color-style')) {
    const style = document.createElement('style');
    style.id = 'hv-premium-color-style';
    style.textContent = `
      .hv-premium-color-control{position:relative;display:flex;align-items:center;width:100%;height:54px;background:#fff;border:1px solid #d7dee8;border-radius:13px;box-shadow:0 1px 2px rgba(15,36,64,.03);transition:border-color .2s ease,box-shadow .2s ease;overflow:hidden}
      .hv-premium-color-control:focus-within{border-color:#0f2440;box-shadow:0 0 0 3px rgba(15,36,64,.08)}
      .hv-premium-color-dot{position:absolute;left:17px;width:19px;height:19px;border-radius:50%;border:1px solid rgba(15,36,64,.16);box-shadow:inset 0 0 0 1px rgba(255,255,255,.45);pointer-events:none;z-index:2}
      .hv-color-black{background:#1a1a1a}.hv-color-white{background:#f7f7f5}.hv-color-blue{background:#1d6fdb}.hv-color-silver{background:linear-gradient(145deg,#aeb2b8,#eef0f3 50%,#aeb2b8)}
      .hv-premium-color-select{appearance:none;-webkit-appearance:none;width:100%;height:100%;border:0!important;outline:0!important;background:transparent!important;color:#0f2440;font:600 15px/1 -apple-system,BlinkMacSystemFont,system-ui,sans-serif;padding:0 46px 0 48px;cursor:pointer;box-shadow:none!important}
      .hv-premium-color-chevron{position:absolute;right:17px;width:9px;height:9px;border-right:1.7px solid #64748b;border-bottom:1.7px solid #64748b;transform:rotate(45deg) translateY(-3px);pointer-events:none}
      .hv-bundle-premium-color-control .hv-premium-color-dot{left:auto;right:48px;width:17px;height:17px}
      .hv-bundle-premium-color-control .hv-premium-color-select{padding:0 78px 0 18px}
      .hv-bundle-color-label{font-size:11px!important;font-weight:700!important;letter-spacing:.7px!important;color:#53657a!important;margin-bottom:7px!important}
      .hv-bundle-color-group{margin-bottom:13px!important}
      .product-form__input--pill.hv-native-color-upgraded>input,.product-form__input--pill.hv-native-color-upgraded>label{display:none!important}
      .product-form__input--pill.hv-native-color-upgraded{display:block!important}
      .product-form__input--pill.hv-native-color-upgraded[aria-hidden="true"]{display:none!important}
      .product-form__input--pill.hv-native-color-upgraded legend{margin-bottom:8px!important}
      @media(max-width:749px){.hv-premium-color-control{height:52px}.hv-premium-color-select{font-size:14px}.hv-bundle-premium-color-control .hv-premium-color-dot{right:46px}}
    `;
    document.head.appendChild(style);
  }

  root.querySelectorAll('.hv-swatch-row').forEach((row) => {
    if (row.dataset.hvPremiumReady === '1') return;
    const buttons = Array.from(row.querySelectorAll('.hv-swatch[data-color]'));
    if (!buttons.length) return;

    const control = document.createElement('div');
    control.className = 'hv-premium-color-control hv-bundle-premium-color-control';
    const dot = document.createElement('span');
    dot.className = 'hv-premium-color-dot';
    const select = document.createElement('select');
    select.className = 'hv-premium-color-select';
    const group = row.closest('.hv-bundle-color-group');
    const groupLabel = group && group.querySelector('.hv-bundle-color-label');
    select.setAttribute('aria-label', groupLabel ? groupLabel.textContent.trim() : 'Choose color');

    buttons.forEach((button) => {
      const option = document.createElement('option');
      option.value = button.dataset.color;
      option.textContent = button.dataset.color;
      select.appendChild(option);
    });

    const active = row.querySelector('.hv-swatch.hv-active') || buttons[0];
    select.value = active.dataset.color;
    updateHydroviaColorControl(control, select.value);

    select.addEventListener('change', () => {
      const target = buttons.find((button) => button.dataset.color === select.value);
      if (target) target.click();
      updateHydroviaColorControl(control, select.value);
    });

    control.appendChild(dot);
    control.appendChild(select);
    const chevron = document.createElement('span');
    chevron.className = 'hv-premium-color-chevron';
    control.appendChild(chevron);
    row.style.display = 'none';
    row.insertAdjacentElement('afterend', control);
    row.dataset.hvPremiumReady = '1';
  });

  root.querySelectorAll('.product-form__input--pill').forEach((picker) => {
    if (picker.dataset.hvPremiumReady === '1') return;
    const radios = Array.from(picker.querySelectorAll('input[type="radio"]'));
    if (!radios.length) return;

    const control = document.createElement('div');
    control.className = 'hv-premium-color-control';
    const dot = document.createElement('span');
    dot.className = 'hv-premium-color-dot';
    const select = document.createElement('select');
    select.className = 'hv-premium-color-select';
    select.setAttribute('aria-label', 'Choose color');

    radios.forEach((radio) => {
      const option = document.createElement('option');
      option.value = radio.value;
      option.textContent = radio.value;
      select.appendChild(option);
      radio.addEventListener('change', () => {
        if (radio.checked) {
          select.value = radio.value;
          updateHydroviaColorControl(control, radio.value);
        }
      });
    });

    const checked = radios.find((radio) => radio.checked) || radios[0];
    select.value = checked.value;
    updateHydroviaColorControl(control, checked.value);

    select.addEventListener('change', () => {
      const target = radios.find((radio) => radio.value === select.value);
      if (!target) return;
      target.click();
      target.dispatchEvent(new Event('change', { bubbles: true }));
      updateHydroviaColorControl(control, select.value);
    });

    control.appendChild(dot);
    control.appendChild(select);
    const chevron = document.createElement('span');
    chevron.className = 'hv-premium-color-chevron';
    control.appendChild(chevron);
    picker.appendChild(control);
    picker.classList.add('hv-native-color-upgraded');
    picker.dataset.hvPremiumReady = '1';
  });

  updateHydroviaNativeColorVisibility();
}

removeHydroviaFlashSale();

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
  removeHydroviaFlashSale();
  wrapHydroviaBundleSelector();
  updateHydroviaPricing(document);
  installHydroviaPopup();
  installHydroviaColorSelectors(document);

  const pricingObserver = new MutationObserver(() => {
    wrapHydroviaBundleSelector();
    updateHydroviaPricing(document);
    installHydroviaColorSelectors(document);
  });
  pricingObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
});

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initializeScrollAnimationTrigger(event.target, true);
    removeHydroviaFlashSale(event.target);
    setTimeout(() => {
      wrapHydroviaBundleSelector();
      updateHydroviaPricing(document);
      installHydroviaColorSelectors(event.target);
    }, 50);
  });
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
